/* ==========================================================================
   FSR – Oktoberaktion 2026: Aktionsfeld in Hero-Bannern + über dem CTA
   (Uta, 02.10./05.10.: Aktion soll auf Startseite, Kollektionsseiten und
   Produktseiten immer präsent sein; im Hero statt Beschreibung + Designpreis.)

   - Nur im Aktionszeitraum sichtbar; danach erscheint nichts mehr.
   - LIVE = false  -> nur mit ?okt_banner=a oder ?okt_banner=b in der URL sichtbar (Vorschau,
     Kunden sehen nichts). LIVE = true -> für alle (Variante = DEFAULT_VARIANT).
   - Rückbau: Script-Zeile in layout/theme.liquid entfernen, Datei löschen. Die ausgeblendeten
     Texte (Beschreibung/Designpreis) werden nur per CSS-Klasse versteckt und kommen dann zurück.
   ========================================================================== */
(function () {
  'use strict';
  var LIVE = true;
  var DEFAULT_VARIANT = 'a';
  var START = Date.parse('2026-10-01T22:00:00Z');
  var END = Date.parse('2026-10-12T22:00:00Z');

  if (/[?&]okt_banner=off/.test(location.search)) return; /* Vorschau ohne Aktionsfeld */
  var q = (location.search.match(/[?&]okt_banner=([ab])/) || [])[1];
  if (!LIVE && !q) return;
  var now = Date.now();
  if (now < START || now >= END) return;
  var variant = q || DEFAULT_VARIANT;

  var lang = ((window.Shopify && window.Shopify.locale) || 'de').slice(0, 2);
  var T = {
    de: { k: 'Oktober-Vorteil · bis 12.10.', h: '2 gleiche: −15 % · ab 3: −20 %', s: 'Sets &amp; Produkte · Farben kombinierbar · automatisch im Warenkorb' },
    en: { k: 'October offer · until 12 Oct', h: '2 identical: −15% · from 3: −20%', s: 'Sets &amp; products · colours can be combined · applied automatically in the cart' },
    fr: { k: 'Offre d’octobre · jusqu’au 12 oct.', h: '2 identiques : −15 % · dès 3 : −20 %', s: 'Sets &amp; produits · couleurs combinables · remise automatique dans le panier' }
  };
  var t = T[lang] || T.de;

  var css = '' +
    '.fsr-okt-box{box-sizing:border-box;text-align:center;margin:1.1rem auto 0;padding:.9rem 1.4rem;max-width:34rem;border-radius:2px;line-height:1.25;}' +
    '.fsr-okt-box p{margin:0!important;}' +
    '.fsr-okt-box .k{font-size:.72rem;letter-spacing:.16em;text-transform:uppercase;font-weight:700;opacity:.95;}' +
    '.fsr-okt-box .h{font-size:1.45rem;font-weight:800;letter-spacing:.03em;text-transform:uppercase;margin-top:.3rem!important;}' +
    '.fsr-okt-box .s{font-size:.78rem;margin-top:.35rem!important;opacity:.9;}' +
    '.fsr-okt-box--a{background:#b4452a;color:#fff;}' +
    '.fsr-okt-box--b{background:#f4f0e8;color:#1b1b1b;border:2px solid #b4452a;}' +
    '.fsr-okt-box--b .h{color:#b4452a;}' +
    '.fsr-okt-box--cta{max-width:none;margin:0 0 1rem;padding:.7rem 1rem;}' +
    '.fsr-okt-box--cta .h{font-size:1.05rem;}' +
    '.fsr-okt-hide{display:none!important;}' +
    '@media(max-width:699px){.fsr-okt-box{padding:.75rem 1rem;max-width:100%;}.fsr-okt-box .h{font-size:1.1rem;}.fsr-okt-box--cta .h{font-size:.95rem;}}';
  var st = document.createElement('style');
  st.id = 'fsr-okt-banner-css';
  st.textContent = css;
  document.head.appendChild(st);

  function box(extra) {
    var d = document.createElement('div');
    d.className = 'fsr-okt-box fsr-okt-box--' + variant + (extra ? ' fsr-okt-box--' + extra : '');
    d.setAttribute('data-fsr-okt', '1');
    d.innerHTML = '<p class="k">' + t.k + '</p><p class="h">' + t.h + '</p><p class="s">' + t.s + '</p>';
    return d;
  }

  function run() {
    if (document.querySelector('[data-fsr-okt]')) return;
    var path = location.pathname.replace(/^\/(en|fr)(?=\/|$)/, '');

    /* Startseite: erster (Haupt-)Hero */
    if (path === '/' || path === '') {
      var hero = document.querySelector('[id^="shopify-section-template--"][id$="__slideshow"]');
      var content = hero && hero.querySelector('.slideshow__slide-content');
      if (content) content.appendChild(box());
      return;
    }

    /* Kollektionsseiten: Name bleibt, Beschreibung + Designpreis weichen dem Aktionsfeld
       (Aktionsseite selbst zeigt die Aktion schon in diesen Feldern) */
    if (/^\/collections\//.test(path) && path.indexOf('/products/') === -1) {
      if (/^\/collections\/oktober-vorteil/.test(path)) return;
      var prose = document.querySelector('collection-banner .prose, [id*="collection-banner"] .prose');
      if (prose) {
        [].forEach.call(prose.querySelectorAll('.fsr-banner-subline, .fsr-banner-award-row, .fsr-banner-award'), function (e) { e.classList.add('fsr-okt-hide'); });
        var h1 = prose.querySelector('h1');
        var b = box();
        if (h1 && h1.parentNode === prose) h1.insertAdjacentElement('afterend', b); else prose.appendChild(b);
      }
      return;
    }

    /* Produktseiten: über dem Kaufbutton */
    if (/^\/products\//.test(path)) {
      var buy = document.querySelector('product-form buy-buttons, buy-buttons');
      if (buy) buy.insertAdjacentElement('beforebegin', box('cta'));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
